// src/api/schemas.js
import { getJWT } from "./auth";
const API_BASE = process.env.REACT_APP_API_SCHEMA_BASE || "/api";

export async function listSchemas() {
  const jwt = await getJWT();
//   console.log("API_BASE =", process.env.REACT_APP_API_SCHEMA_BASE);
// const url = `${process.env.REACT_APP_API_SCHEMA_BASE}/schemas`;
// console.log("Request URL =", url);
  const r = await fetch(`${API_BASE}/schemas`, {
    headers: { Authorization: `Bearer ${jwt}` },
  });
  if (!r.ok) throw new Error(`List failed: ${r.status} ${await r.text()}`);
  return r.json(); // => [{ userSub, schemaId, name, version, definition, updatedAt }]
}

export async function getSchema(schemaId) {
  const jwt = await getJWT();
  const r = await fetch(`${API_BASE}/schemas/${encodeURIComponent(schemaId)}`, {
    headers: { Authorization: `Bearer ${jwt}` },
  });
  if (r.status === 404) return null;
  if (!r.ok) throw new Error(`Get failed: ${r.status}`);
  return r.json();
}

export async function saveSchema(schema) {
  // schema = { name, definition, version?, schemaId? }
  const jwt = await getJWT();
  const r = await fetch(`${API_BASE}/schemas`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwt}`,
    },
    body: JSON.stringify(schema),
  });
  if (!r.ok) throw new Error(`Save failed: ${r.status} ${await r.text()}`);
  return r.json(); // => created/updated item
}

export async function deleteSchema(schemaId) {
  const jwt = await getJWT();
  const r = await fetch(`${API_BASE}/schemas/${encodeURIComponent(schemaId)}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${jwt}` },
  });
  if (r.status !== 204) throw new Error(`Delete failed: ${r.status}`);
}
